import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const NavBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled(Typography)``;

export const Nav = styled.div``;

export const NavList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: spage-between;
  align-items: center;
  gap: 1rem;
`;
